import {
	COMPARISON_HEADER_CONTENT,
	FUNNEL_CURRENT_PROVIDER,
} from "@/data/consts";
import Head from "next/head";
import * as React from "react";
import Nav from "@/components/Nav";
import Header from "@/components/Header";
import { getOne } from "@/api/contentful";
import { LeadContext } from "@/context/lead";
import ProtectedRoute from "@/components/ProtectedRoute";
import CompactFooter from "@/components/Footer/CompactFooter";
import HeaderContent from "@/components/Comparison/HeaderContent";
import { HeaderContent as HeaderContentType } from "@/types/header";
import { CurrentProvider as CurrentProviderType } from "@/types/index";
import CurrentProvider from "@/components/BroadbandLead/CurrentProvider";

const Providers: React.FC<{
	data: CurrentProviderType;
	headerContent: HeaderContentType;
}> = ({ data, headerContent }) => {
	const { postcode, address } = React.useContext(LeadContext);
	const { variant } = React.useContext(LeadContext);

	return (
		<ProtectedRoute isAuthed={postcode !== "" && address !== null}>
			<div className="h-100 d-flex flex-column">
				<Head>
					<title>Current Provider | Savely</title>
					<meta
						name="description"
						content="Let us know your current provider so we can help tailor our broadband deals for you."
					/>
				</Head>
				{variant == 1 ? (
					<Header
						left={<HeaderContent data={headerContent} />}
						right={<></>}
						theme={{
							paddingTop: 0,
							paddingRight: 0,
							paddingLeft: 0,
							paddingBottom: 5,
						}}
					/>
				) : (
					<Nav hideMenu={true} logoLink={"/journey/broadband"} theme="dark" />
				)}
				<CurrentProvider data={data} />
				<CompactFooter />
			</div>
		</ProtectedRoute>
	);
};

export async function getStaticProps() {
	const data = await getOne(FUNNEL_CURRENT_PROVIDER);
	const headerContent = await getOne(COMPARISON_HEADER_CONTENT);

	return {
		props: {
			data,
			headerContent,
		},
		revalidate: Number(process.env.REVALIDATE_CONTENTFUL),
	};
}

export default Providers;
